import { cn } from '@/lib/utils';
import FooterV2 from '@components/FooterV2';
import AIAdaptabilityGraph from '@components/GenAICertificateProgram/AIAdaptabilityGraph';
import AudienceIcons from '@components/GenAICertificateProgram/AudienceIcons';
import GenAIProgramPage from '@components/GenAICertificateProgram/GenAIProgramPage';
import Heading from '@components/GenAICertificateProgram/Heading';
import InfoCard from '@components/GenAICertificateProgram/InfoCard';
import ReasonCards from '@components/GenAICertificateProgram/ReasonCards';
import Text from '@components/GenAICertificateProgram/Text';
import Wrapper from '@components/GenAICertificateProgram/Wrapper';
import CompaniesSection from '@components/v5/CompaniesSection';
import React, { useRef } from 'react';
import { useLocation } from '@reach/router';
import ScrollButtonComponent from '@components/ScrollButtonComponent';
import GenAICTA from '@components/GenAICertificateProgram/GenAICTA/GenAICTA';
import FormSubmitButton from '@components/LeadGenerationForm/FormComponents/FormSubmitButton';

const GenAICertificateProgram = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const slug = params.get('slug');
  const leadFormRef = useRef();

  const ChooseYourDomainButton = () => {
    return (
      <div className="flex items-center justify-center">
        <a className="" href="#explore-domains">
          <FormSubmitButton text={'Choose Your Domain'} className={''} />
        </a>
      </div>
    );
  };

  const CrioSuccessBanner = () => {
    const Label = ({ children }) => {
      return (
        <h3 className="font-manrope text-[39.82px] font-bold leading-[100%] text-[#009378] md:text-[61.56px]">
          {children}
        </h3>
      );
    };

    const Title = ({ children }) => {
      return (
        <p className="mt-1 text-[12px] font-medium leading-[100%] text-[#525252] md:text-[16px]">
          {children}
        </p>
      );
    };

    return (
      <>
        <img
          src={`/images/GenAI/Beaver.png`}
          alt={'hero'}
          className="w-full max-w-[180px] rounded-md object-contain md:hidden"
        />
        <div className="mx-auto mb-4 flex max-w-[1100px] flex-col items-center justify-between gap-6 rounded-2xl border-[1px] bg-white px-6 py-6 shadow-md md:flex-row md:px-8 md:py-8">
          {/* Left Title Section */}
          <div className="text-center font-manrope text-[24px] font-extrabold capitalize leading-[54px] tracking-normal text-[#009378] md:text-left md:text-[50px] md:leading-[54px]">
            Crio Success
          </div>

          {/* Stats Section */}
          <div className="flex w-full flex-col items-center justify-evenly gap-8 text-center md:w-3/4 md:flex-row md:gap-12">
            {/* Stat 1 */}
            <div>
              <Label>95%</Label>
              <Title>Placed Graduates</Title>
            </div>

            {/* Divider */}
            <div className="hidden h-12 w-px bg-gray-300 md:block" />

            {/* Stat 2 */}
            <div>
              <Label>1500+</Label>
              <Title>Hiring Partners</Title>
            </div>

            {/* Divider */}
            <div className="hidden h-12 w-px bg-gray-300 md:block" />

            {/* Stat 3 */}
            <div>
              <Label>81%</Label>
              <Title>Average Salary Hike</Title>
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <div id={'top'}>
      {slug && (
        <ScrollButtonComponent
          component={
            <div className="flex items-center justify-center">
              <a className="" href="#top">
                <FormSubmitButton
                  text={'Reserve Your Spot Now'}
                  className={''}
                />
              </a>
            </div>
          }
          startAt={600}
        ></ScrollButtonComponent>
      )}
      <div className="flex h-[80px] items-center justify-center">
        {' '}
        <img
          src={`/images/GenAI/Light.png`}
          alt={'hero'}
          className="h-[50px] rounded-md object-contain"
        />
      </div>
      {slug ? (
        <GenAIProgramPage slug={slug} />
      ) : (
        <>
          <div
            className={cn(
              'flex flex-col-reverse items-center gap-4 px-4 py-4',
              'md:flex-row',
            )}
          >
            <div className="mx-auto max-w-4xl space-y-3 bg-white md:space-y-6 md:p-8">
              <Heading>Professional Gen-AI Certificate Program.</Heading>

              <p
                className={cn(
                  'text-center font-rubik text-[16px] font-bold capitalize leading-[26px] tracking-normal text-[#009378] ',
                  'md:text-left md:text-[20px]',
                )}
              >
                Learn By Doing → Lead By Knowing.
              </p>

              <Text>
                For Ambitious Professionals Ready To{' '}
                <span className="font-semibold">Reinvent</span> Their Role And{' '}
                <span className="font-semibold">Relevance</span> In The Age Of
                AI.
              </Text>
              <Text>
                No Tech Background Needed. Become Certified Gen-AI Specialist.
              </Text>

              <div className="flex justify-start gap-4 pt-4 md:flex-row">
                <InfoCard
                  label={'200+'}
                  subtext={'Hours Of Hands-On Learning'}
                />
                <InfoCard label={'20+'} subtext={'AI-Tools Proficiency'} />
                <InfoCard label={'10X'} subtext={'Performance Impact'} />
              </div>
            </div>
            <div>
              <img
                src={`/images/GenAI/GenAIHero.png`}
                alt={'hero'}
                className="w-full rounded-md object-contain md:w-[520px]"
              />
            </div>
            <h1
              className={cn(
                'text-center font-manrope text-[24px] font-extrabold capitalize leading-[34px] tracking-normal text-black',
                'md:hidden md:text-left md:text-[42px] md:leading-[54px]',
              )}
            >
              Professional Gen-AI Certificate Program.
            </h1>
          </div>
          <Wrapper>
            <div ref={leadFormRef} id={'explore-domains'}>
              <Heading className="md:text-center">
                Find Your Possibilities - Reinvent with Purpose
              </Heading>
              <Text className="md:text-center">
                Choose your domain and discover how GenAI can elevate your
                skills and impact
              </Text>
              <AudienceIcons></AudienceIcons>
            </div>
          </Wrapper>

          <div className="flex justify-center">
            <AIAdaptabilityGraph />
          </div>

          <Wrapper>
            <Heading className="md:text-center">Why Reinvent?</Heading>

            <div className="flex flex-col items-center justify-center md:flex-row">
              <div className="space-y-2 md:space-y-4">
                <Heading className={'text-[16px] md:mb-0'}>
                  The New Hiring Imperative
                </Heading>
                <Text className={''}>AI Aptitude takes center stage.</Text>
                <div className="inline-block rounded-xl bg-[#E9F7F6] px-6 py-2">
                  <Text> Work Trend Index Annual Report</Text>
                </div>
              </div>
              <div className="my-3">
                <img
                  src={`/images/GenAI/Reinvent.png`}
                  alt={'hero'}
                  className="hidden w-full rounded-md object-contain md:block md:w-[520px]"
                />
                <img
                  src={`/images/GenAI/Reinvent-Mobile.png`}
                  alt={'hero'}
                  className="block w-full rounded-md object-contain md:hidden md:w-[520px]"
                />
              </div>
            </div>
          </Wrapper>
          <Wrapper>
            <Heading className={'md:text-center'}>
              Because staying relevant isn't optional anymore.{' '}
              <br className="hidden md:block" />
              <span className="text-[#009378]">
                Reinvent your skills & Reclaim your edge
              </span>
            </Heading>
            <ReasonCards />
          </Wrapper>
          <ChooseYourDomainButton />
          <Wrapper>
            <Heading className={'md:text-center'}>How do you learn?</Heading>
            <div className="flex items-center justify-center">
              <img
                src={`/images/GenAI/HowDoYouLearn.png`}
                alt={'hero'}
                className="hidden w-full max-w-[1120px] rounded-md object-contain md:block"
              />
              <img
                src={`/images/GenAI/HowDoYouLearn-Mobile.png`}
                alt={'hero'}
                className="block w-full rounded-md object-contain md:hidden"
              />
            </div>
          </Wrapper>
          <Wrapper>
            <Heading className={'md:text-center'}>About Crio.Do</Heading>
            <div className="mx-auto flex max-w-[1100px] items-center justify-center">
              <img
                src={`/images/GenAI/Beaver.png`}
                alt={'hero'}
                className="hidden w-full max-w-[330px] rounded-md object-contain md:block"
              />
              <div className="flex flex-col gap-6">
                <Text>
                  At Crio, we’ve spent years helping tech professionals upskill
                  with real-world, industry-ready experiences.
                </Text>
                <Text>
                  Now, we’re building on that foundation to give non-tech
                  professionals the skills, tools, and confidence to harness
                  GenAI at work with Learn by Doing & Lead by Knowing.
                </Text>
                <Text>
                  This isn’t about learning a new tool. It’s about redefining
                  your value in a world shaped by GenAI.
                </Text>
              </div>
            </div>
            <CrioSuccessBanner />
          </Wrapper>
          <ChooseYourDomainButton />
          <CompaniesSection></CompaniesSection>
          <div className="mx-4 mb-4">
            <GenAICTA
              onClick={() =>
                leadFormRef.current?.scrollIntoView({ behavior: 'smooth' })
              }
            />
          </div>
        </>
      )}
      <FooterV2 />
    </div>
  );
};

export default GenAICertificateProgram;
